/* eslint-disable */
/**
 * Custom Plaid GraphQL mutations
 * These are manually maintained to avoid over-fetching and to prevent
 * being overwritten by Amplify codegen.
 *
 * NOTE: Do NOT use auto-generated mutations from src/graphql/mutations.ts for Plaid.
 * Those expose plaidAccessToken which is a security risk.
 * Sent to the CDK AppSync API by app/services/plaid.service.ts and served by the
 * v2Shared Lambda (SEE-1652 / SEE-1228), which replaced the plaidApiResolver Lambda.
 */

/**
 * Create a Plaid Link token to initialize the Plaid Link widget.
 */
export const plaidLinkTokenCreate = /* GraphQL */ `
  mutation PlaidLinkTokenCreate($userId: ID!, $redirectUri: String!, $stepUpGrant: String) {
    plaidLinkTokenCreate(userId: $userId, redirectUri: $redirectUri, stepUpGrant: $stepUpGrant) {
      link_token
      expiration
      request_id
    }
  }
`;

/**
 * Exchange public_token for processor_token (used for instantly verified accounts).
 * accountType must be 'checking' or 'savings' - Highnote only supports these types.
 * @deprecated Use linkPlaidBankAccount instead for better security.
 */
export const plaidLinkTokenExchange = /* GraphQL */ `
  mutation PlaidLinkTokenExchange($publicToken: String!, $accountId: String!, $accountType: String!) {
    plaidLinkTokenExchange(publicToken: $publicToken, accountId: $accountId, accountType: $accountType) {
      processor_token
      request_id
    }
  }
`;

/**
 * Link a bank account via Plaid securely.
 * Exchanges public_token, stores access_token server-side, and returns only safe data.
 * This is the preferred method - access_token NEVER leaves the backend.
 */
export const linkPlaidBankAccount = /* GraphQL */ `
  mutation LinkPlaidBankAccount($input: LinkPlaidBankAccountInput!) {
    linkPlaidBankAccount(input: $input) {
      id
      paidolId
      plaidAccountId
      plaidItemId
      highnoteAccountId
      accountName
      accountMask
      accountType
      verificationMethod
      status
      linkedAt
      verifiedAt
    }
  }
`;

/**
 * Update the status of a PlaidLinkedBankAccount.
 * Used after verification or to close an account.
 */
export const updatePlaidLinkedBankAccountStatus = /* GraphQL */ `
  mutation UpdatePlaidLinkedBankAccountStatus(
    $id: ID!
    $status: String!
    $highnoteAccountId: String
    $failureReason: String
  ) {
    updatePlaidLinkedBankAccountStatus(
      id: $id
      status: $status
      highnoteAccountId: $highnoteAccountId
      failureReason: $failureReason
    ) {
      id
      paidolId
      plaidAccountId
      plaidItemId
      highnoteAccountId
      accountName
      accountMask
      accountType
      verificationMethod
      status
      linkedAt
      verifiedAt
      closedAt
      failureReason
    }
  }
`;

/**
 * Create a verification link token for a pending micro-deposit account.
 * Uses the stored access_token server-side - never exposes it to frontend.
 */
export const createVerificationLinkTokenForAccount = /* GraphQL */ `
  mutation CreateVerificationLinkTokenForAccount($accountId: ID!, $userId: ID!, $stepUpGrant: String) {
    createVerificationLinkTokenForAccount(accountId: $accountId, userId: $userId, stepUpGrant: $stepUpGrant) {
      link_token
      expiration
      request_id
    }
  }
`;

/**
 * Complete verification and create processor token for a pending account.
 * Returns the processor_token needed for Highnote, but keeps access_token server-side.
 */
export const completeVerificationAndCreateProcessorToken = /* GraphQL */ `
  mutation CompleteVerificationAndCreateProcessorToken($accountId: ID!, $highnoteAccountId: String) {
    completeVerificationAndCreateProcessorToken(
      accountId: $accountId
      highnoteAccountId: $highnoteAccountId
    ) {
      processorToken
      accountId
    }
  }
`;
